import { useMutation } from '@tanstack/react-query';
import { Divider, Spin } from 'antd';
import { GET_CUSTOMER_RECOMMEND_BY_BRANCH } from 'apis/GraphQL/Queries/customerQuery';
import axiosGraphQL from 'apis/GraphQL/axiosGraphQL';
import { Dispatch, useEffect, useMemo, useState } from 'react';
import CustomerCard from './CustomerCard';
import { IRouteInfo } from 'interfaces/SaleLine';

const NUMBER_OF_CUSTOMER = 3;

interface IProps {
  data: any[];
  salePlaningId: number;
  routeInfo?: IRouteInfo;
  implementationDate?: string;
  setNewCustomer: (data: any) => void;
  setData: (data: any) => void;
  setOpenMap: Dispatch<boolean>;
  setLocation: Dispatch<any>;
}

const CUS_TYPE = 'system';

export default function Recommended(props: IProps) {
  const {
    data,
    salePlaningId,
    routeInfo,
    implementationDate,
    setData,
    setOpenMap,
    setLocation,
    setNewCustomer,
  } = props;
  const [pageInfo, setPageInfo] = useState<any>({});
  const [skip, setSkip] = useState(0);
  const dateRecommend = useMemo(() => {
    const date = implementationDate ? new Date(implementationDate) : new Date();
    return {
      month: date.getMonth() + 1,
      year: date.getFullYear(),
      day: date.getDate(),
    };
  }, [implementationDate]);

  const params = {
    query: GET_CUSTOMER_RECOMMEND_BY_BRANCH,
    variables: {
      skip,
      take: NUMBER_OF_CUSTOMER,
      input: {
        routeId: routeInfo?.id,
        month: dateRecommend.month,
        year: dateRecommend.year,
        day: dateRecommend.day,
        salePlanningId: salePlaningId,
      },
    },
  };

  const { isPending: getUserRecommendLoading, mutate: getUserRecommend } =
    useMutation({
      mutationFn: () => axiosGraphQL.post('/graphql', params),
      onSuccess: (data: any) => {
        const items = data.data?.getProposeCustToSalesPlanning?.items;

        if (!items?.length) return;

        setData((prev: any) => ({
          ...prev,
          [CUS_TYPE]: [
            ...prev[CUS_TYPE],
            ...items.map((item: any) => ({
              ...item,
              id: item.customerId || item.id,
            })),
          ],
        }));
        setPageInfo(data.data.getProposeCustToSalesPlanning.pageInfo);
        setSkip(skip + NUMBER_OF_CUSTOMER);
      },
      onError: (error) => {
        console.log(error);
      },
    });

  const getMoreRecommend = () => {
    getUserRecommend();
  };

  useEffect(() => {
    getUserRecommend();
  }, [getUserRecommend]);

  return (
    <Spin spinning={getUserRecommendLoading}>
      <div
        style={{
          flexGrow: 0,
          overflow: 'auto',
          minHeight: '400px',
          maxHeight: '400px',
        }}
      >
        {/* Hệ thống đề xuất */}
        {(data || []).length == 0 ? (
          'Không có khách hàng đề xuất'
        ) : (
          <CustomerCard
            data={data}
            setData={setData}
            setOpenMap={setOpenMap}
            setLocation={setLocation}
            handleAddCusomer={setNewCustomer}
            cusType={CUS_TYPE}
          />
        )}
      </div>

      <Divider />
      {pageInfo.hasNextPage && (
        <button onClick={getMoreRecommend}>
          <span style={{ color: '#003056', fontWeight: 'bold' }}>
            Đề xuất thêm
          </span>
        </button>
      )}
    </Spin>
  );
}
